import TagIconQuestion from './TagIconQuestion';

export default TagIconQuestion;
